import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { useReactQueryHelpers } from "shared/hooks/useReactQueryHelpers";
import { RX_LOOKUP_GET_ENDPOINT } from "features/user/RxLookup/RxLookupConstants";

export function useMatchClaimsAndPayments() {
  const { oktaAuth } = useOktaAuth();
  const { invalidateReactQueryKey } = useReactQueryHelpers();

  function matchClaimsAndPayments(inputParameters) {
    let accessToken = oktaAuth.getAccessToken();

    let apiParameters = {
      user: inputParameters.user,
      rpid: inputParameters.rpid,
      pyids: inputParameters.pyids,
      clids: inputParameters.clids,
    };

    axios
      .post("api/AdminPaymentMatching/MatchClaimsAndPayments", apiParameters, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((response) => {
        // Invalidate RxLookup cache to refresh data after match operation
        invalidateReactQueryKey(RX_LOOKUP_GET_ENDPOINT);
        inputParameters.callback();
      })
      .catch((e) => {
        console.log("Post request failed:", e);
        inputParameters.callback();
      });
  }

  return useMutation({
    mutationFn: async (mutateParameter) => {
      matchClaimsAndPayments(mutateParameter);
    },
  });
}
